import Select from './_select';
import SelectOption from './select-option';
import SelectOptionGroup from './select-option-group';

Select.SelectOption = SelectOption;
Select.SelectOptionGroup = SelectOptionGroup;

export default Select;
